import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import Chat from "@material-ui/icons/Chat";
import VerifiedUser from "@material-ui/icons/VerifiedUser";
import Fingerprint from "@material-ui/icons/Fingerprint";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import InfoArea from "components/InfoArea/InfoArea.js";

import ProjectCalculator from "components/ProjectCalculator/ProjectCalculator.js";

import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";

import logo from "assets/img/logo-512.png";

const useStyles = makeStyles(styles);

export default function CalculatorSection() {
  const classes = useStyles();
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRoundedCircle,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={12}>

          <ProjectCalculator />

        </GridItem>
      </GridContainer>
    </div>
  );
}
